import { useVoixUserAuth } from "@voix/composables/useVoixUserAuth";
import { useSiteUtils } from "@voix/composables/useSiteUtils";
import { getAvailableSites } from "@voix/composables/queries/useQuerySites";
export async function useVoixMenus() {
  await getAvailableSites();
  const { getCurrentDomain } = useSiteUtils();
  const { checkUserPermissions } = useVoixUserAuth();
  const availableMenus = [];
  const domain = getCurrentDomain();
  async function buildMenus(allMenus) {
    const keys = Object.keys(allMenus);
    const menusPromises = keys.map(async (menuKey) => {
      const menu = allMenus[menuKey];
      const links = menu.links.map(async (link) => {
        const permissions = link.permissions;
        if (link.sites && !link.sites.includes(domain))
          return null;
        if (permissions) {
          const hasPermissions = await checkUserPermissions(permissions);
          if (hasPermissions)
            return link;
        } else {
          return link;
        }
      });
      const resolvedLinks = await Promise.all(links);
      const filteredLinks = resolvedLinks.filter((link) => link);
      if (filteredLinks.length > 0) {
        availableMenus.push({
          ...menu,
          links: filteredLinks
        });
      }
    });
    await Promise.all(menusPromises);
    return availableMenus;
  }
  return { buildMenus };
}
